"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Messages = function Messages(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 22 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 15 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#fff' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Messages' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Messages' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 22 15"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-1",
    points: "0 0.000136363636 22 0.000136363636 22 15.0001364 0 15.0001364"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-1194.000000, -29.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Messages",
    transform: "translate(1194.000000, 29.000000)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask-2",
    fill: color
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.29411765,13.6365 L20.7058824,13.6365 L20.7058824,1.36377273 L1.29411765,1.36377273 L1.29411765,13.6365 Z M21.3529412,15.0001364 L0.647058824,15.0001364 C0.289882353,15.0001364 0,14.6946818 0,14.3183182 L0,0.681954545 C0,0.305590909 0.289882353,0.000136363636 0.647058824,0.000136363636 L21.3529412,0.000136363636 C21.7101176,0.000136363636 22,0.305590909 22,0.681954545 L22,14.3183182 C22,14.6946818 21.7101176,15.0001364 21.3529412,15.0001364 Z",
    id: "Fill-1",
    fill: color,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.0001294,9.46172727 C10.8655412,9.46172727 10.7309529,9.41809091 10.6144824,9.32672727 L0.261541176,1.22945455 C-0.0257529412,1.00445455 -0.0852823529,0.577636364 0.128247059,0.276272727 C0.341776471,-0.0264545455 0.746835294,-0.0878181818 1.03283529,0.134454545 L11.3857765,8.23309091 C11.6730706,8.45672727 11.7326,8.88354545 11.5190706,9.18627273 C11.3935412,9.36763636 11.1968353,9.46172727 11.0001294,9.46172727",
    id: "Fill-3",
    fill: color,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.0001294,9.41372727 C10.8021294,9.41372727 10.6054235,9.31827273 10.4798941,9.13554545 C10.2676588,8.83281818 10.3271882,8.406 10.6157765,8.18236364 L20.9687176,0.132818182 C21.2547176,-0.0908181818 21.6610706,-0.0253636364 21.8733059,0.277363636 C22.0855412,0.580090909 22.0260118,1.00690909 21.7374235,1.23054545 L11.3844824,9.27872727 C11.2693059,9.37009091 11.1347176,9.41372727 11.0001294,9.41372727",
    id: "Fill-4",
    fill: color,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.647188235,15.0001364 C0.484129412,15.0001364 0.319776471,14.9346818 0.194247059,14.8051364 C-0.0606941176,14.5419545 -0.0658705882,14.1110455 0.185188235,13.8410455 L5.32671765,8.30740909 C5.57648235,8.04013636 5.98930588,8.03468182 6.24165882,8.2965 C6.49789412,8.56104545 6.50177647,8.99331818 6.25201176,9.26195455 L1.10918824,14.7955909 C0.983658824,14.9319545 0.815423529,15.0001364 0.647188235,15.0001364",
    id: "Fill-5",
    fill: color,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.3530706,15.0001364 C21.1861294,15.0001364 21.0204824,14.9319545 20.8936588,14.7996818 L15.6835412,9.26468182 C15.4324824,8.99740909 15.4350706,8.56513636 15.6874235,8.30059091 C15.9423647,8.03468182 16.3513059,8.03740909 16.6036588,8.30468182 L21.8124824,13.8369545 C22.0648353,14.1055909 22.0622471,14.5365 21.8098941,14.8024091 C21.6830706,14.9346818 21.5174235,15.0001364 21.3530706,15.0001364",
    id: "Fill-6",
    fill: color,
    mask: "url(#mask-2)"
  })))));
};
Messages.propTypes = _index.iconProps;
var _default = Messages;
exports["default"] = _default;